module.exports = __webpack_public_path__ + "static/media/TA273_2.9408f7a6.png";